import styled, { css } from "styled-components";
import { Transitions } from "core/constants";
import { backgroundColorSelector } from "core/styles/colorStyle";
import { getPaddingStyle, getMarginStyle, GetPaddingStyle } from "core/styles/paddingMarginStyle";
import { CardProps } from ".";

const zoomStyle = ({ zoom }: any) =>
  zoom &&
  css`
    &:hover {
      transform: scale(1.025);
      transition: transform 0.2s ${Transitions.cubicBezier};
    }
  `;

export const Container = styled.div<CardProps>`
  display: flex;
  position: relative;
  flex-direction: ${({ direction }) => direction};
  overflow: hidden;
  font-family: Nunito-Sans;
  width: ${({ width }) => width};
  min-height: ${({ height }) => height};
  border: ${({ border, theme }) => (border ? `1px solid ${theme?.colors?.gray.gray10}` : "unset")};
  border-radius: ${({ radius }) => (radius === 0 ? 0 : `${radius}px`)};
  box-shadow: ${({ shadow }) => shadow && "0px 1px 3px 0px #0000001a, 0px 1px 2px 0px #0000000f"};
  cursor: ${({ onClick }) => onClick && "pointer"};

  ${zoomStyle}
  ${getMarginStyle}
  ${getPaddingStyle}
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  background: ${({
    // @ts-expect-error TS(2339): Property 'src' does not exist on type 'Omit<Detail... Remove this comment to see the full error message
    src,
  }) => src && `url(${src})`};
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  padding: 16px;
  min-height: ${({
    // @ts-expect-error TS(2339): Property 'height' does not exist on type 'Omit<Det... Remove this comment to see the full error message
    height,
  }) => height || "240px"};
  z-index: -1;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: ${({
      // @ts-expect-error TS(2339): Property 'opacity' does not exist on type 'Omit<De... Remove this comment to see the full error message
      opacity,
    }) => opacity || 0.88};
    background: ${({
      // @ts-expect-error TS(2339): Property 'overlayColor' does not exist on type 'Om... Remove this comment to see the full error message
      overlayColor,
    }) => overlayColor};
  }
`;

export const BodyContainer = styled.div<{ alignItems: string } & GetPaddingStyle>`
  display: flex;
  padding: 16px;
  flex-grow: 1;
  position: relative;
  flex-direction: column;
  align-items: ${({ alignItems }) => alignItems ?? "unset"};

  ${backgroundColorSelector}
  ${getPaddingStyle}
`;

export const FooterContainer = styled(BodyContainer)``;
